// import { saveAuthInfo } from 'apis/wx-zuth';
import { Toast, Dialog } from 'vant';
import { monitor } from '@/service/monitor';
import {
  isAndroid, isIOS, isAPP, appVersion, isRebateApp, isBoxAPP,
} from './ua';
import version from './utils/version';
import config from './config';
import { UniquePopTo } from '@/service/boxNativeApi';

/**
 * 访问地址
 * http://wiki.int.zuzuche.info/pages/viewpage.action?pageId=6351421
 */
export const { zzc, UniqueJSBridge } = window;
const noop = () => { };

/**
 * 分享微信
 * @param {*} shareParams
 */
export const baseShare = shareParams => new Promise(resolve => {
  window.zzc.call('base_share', {
    ...{
      title: '',
      content: '',
      photo: '', // 图片分享，photo 与 shareUrl (分享链接)互斥，图片大小最好不要超过250k。
      shareUrl: '',
      sharePlatform: ['wxsession', 'wxtimeline', 'copy'], // 可选，不传默认支持wxsession、wxtimeline、copy
      success: resolve,
    },
    ...shareParams,
  });
});

// 小程序分享
export const shareWxMiniProgram = shareParams => new Promise((resolve, reject) => {
  const params = {
    base64Str: '', // 小程序消息封面图片，小于128k——优先使用(注意不能带data:image/*开头)
    imageUrl: 'https://pics5.baidu.com/feed/6609c93d70cf3bc74c068ad0840a9ca6cd112a9d.jpeg?token=c1e045068b319b04a8f7537ed1531bb4', // 小程序消息封面图片，小于128k
    miniProgramId: 'gh_94ba10342d5a', // （必须）小程序原始id
    programPath: 'pages/entry/entry', // （必须）小程序页面路径；
    webPageUrl: '', // （必须）兼容低版本的网页链接
    appId: '', // 移动应用AppId，默认使用原生保存的AppId（注意不是小程序的APPID,一般不用传）
    miniProgramType: 1, // （默认使用正式版）正式版:0，测试版:1，体验版:2
    shareTitle: '', // 小程序消息title
    shareMsg: '', // 小程序消息desc
    ...shareParams,
  };
  console.warn('params', params);
  window.zzc.call('shareWxMiniProgram', {
    ...params,
    complete(response) {
      if (response.state === 0) {
        resolve();
        return;
      }
      reject();
      console.log(response); // response.state == 0：成功，response.state == 1001参数错误
    },
  });
});

/**
 * 获取 token
 * data -> { "userId": xxx, "token": xxx }
 */
export const accountGetInfo = testDate => {
  if (testDate) return testDate;
  if (window.zzcjsbridge && window.zzcjsbridge.account_getInfo) {
    return new Promise(resolve => {
      zzc.call('account_getInfo', {
        success: response => resolve(response.data),
      });
    });
  }
  return {};
};

/**
 * 回到首页
 * tabIndex home(周边)/shop(骑士商城)/vip（尊享特权）/mine（我的）/book（办理）/ shouye(首页)
 */
export const baseBackToHome = tabIndex => zzc.call('base_backToHome', {
  tabIndex,
});

/**
 * 禁止手势返回并控制点击返回按钮行为
 * @param Function callback
 */
export const controlBackLogic = (callback = noop, gesture = 1) => {
  if (isAndroid) {
    zzc.call('base_listenBackButton');
    zzc.on('app:backButtonClick', callback);
  }
  if (isIOS) {
    // 入参，1:禁止返回手势   0：支持返回手势  2：移除中间push的页面  3：自定义右滑手势
    zzc.call('base_controlLeftPanGesture', { off: gesture });
  }
  if (isAPP) {
    window.onpopstate = e => {
      if (e.state === -1) {
        window.history.pushState(0, null); // main state
        callback();
      }
    };
    window.history.pushState(-1, null); // back state
    window.history.pushState(0, null); // main state
  }
};

/**
 * 取消禁止手势返回并控制点击返回按钮行为
 * @param Function callback
 */
export const cancelControlBackLogic = (backStep = -3, url) => {
  if (isAndroid) {
    zzc.call('base_listenBackButton');
    zzc.on('app:backButtonClick', noop);
  }
  if (isIOS) {
    // 入参，1:禁止返回手势   0：支持返回手势  2：移除中间push的页面  3：自定义右滑手势
    zzc.call('base_controlLeftPanGesture', { off: 0 });
  }
  window.onpopstate = () => null;
  if (backStep === 0) return;

  if (url) {
    window.location.replace(url);
  } else {
    window.history.go(backStep);
  }
};

/**
 * 保存 base64 到客户端
 * @param {*} tabIndex
 */
export const baseSaveAlbum = base64Str => new Promise(resolve => {
  window.zzc.call('base_saveToAlbum', {
    type: 'base64',
    base64Str: base64Str.split('base64,')[1],
    success: resolve,
  });
});


/**
 * 调起广告插件
 */
export function playRewardAdVideo(options = {}, type) {
  const adVersion = computedVideoVersion();
  const defaultSlots = {
    v1: {
      android: '945017263',
      ios: '945014509',
    },
    v2: {
      android: '945904136',
      ios: '945887028',
    },
  };
  if (type === 'beiye') {
    options.byAdId = isAndroid ? options.byAndroid : options.byIos;
    // delete options.byAndroid;
    // delete options.byIos;
  }
  if (!options.slotId) {
    const androidSlotId = options.android || defaultSlots[adVersion].android;
    const iosSlotId = options.ios || defaultSlots[adVersion].ios;
    options.slotId = isAndroid ? androidSlotId : iosSlotId;
    // delete options.ios;
    // delete options.android;
  }
  const params = {
    byAdId: options.byAdId || '',
    slotId: options.slotId || '',
  };
  const msgInfo = JSON.stringify(params);
  return new Promise((resolve, reject) => {
    zzc.call('playRewardAdVideo', {
      ...params,
      timeoutInterval: 20,
      success: () => {
        monitor.report({
          level: 'info',
          error: 'video',
          msg: `视频播放成功 ===> ${msgInfo}`,
        });
      },
      complete: res => {
        resolve(res);
        try {
          if (res.state !== 0) {
            monitor.report({
              level: 'error',
              error: 'video',
              msg: `视频播放失败 ===> ${res.message || null},ids:${msgInfo}`,
            });
          }
        } catch (error) { console.log(error); reject(error); }
      },
      error: resolve,
    });
  });
}

/**
 * 调起底部广告插件
 */
export function playBottomAdVideo(options = {}, type) {
  const adVersion = computedVideoVersion();
  const defaultSlots = {
    v1: {
      android: '945017263',
      ios: '945014509',
    },
    v2: {
      android: '945904138',
      ios: '945887495',
    },
  };
  if (type === 'beiye') {
    options.byAdId = isAndroid ? options.byAndroid : options.byIos;
    // delete options.byAndroid;
    // delete options.byIos;
  }
  if (!options.slotId) {
    const androidSlotId = options.android || defaultSlots[adVersion].android;
    const iosSlotId = options.ios || defaultSlots[adVersion].ios;
    options.slotId = isAndroid ? androidSlotId : iosSlotId;
    // delete options.ios;
    // delete options.android;
  }
  const params = {
    byAdId: options.byAdId || '',
    slotId: options.slotId || '',
  };
  const defaultOptions = {
    toBottom: '0', // 可选字段  默认贴底
    sizeStr: '375*94', // 可选字段  默认 '600*90' 可选范围（'600*300' '600*400' '600*500' '600*260' '600*90' '600*150' '640*100' '690*388'）
    byAdId: '10003064', // 倍业bannerId iOS 默认 10003064
  };

  return new Promise(resolve => {
    zzc.call('showBannerAd', {
      ...defaultOptions,
      ...params,
      success: resolve,
    });
  });
}

/**
 * 关闭底部广告
 *
 * @export
 * @returns
 */
export const dismissBottomAd = () => new Promise(resolve => {
  if (window.zzc && window.zzcjsbridge && window.zzcjsbridge.dismissBannerAd) {
    zzc.call('dismissBannerAd', {
      success: resolve,
    });
  }
});

export function toast(content, time) {
  return zzc.call('base_toast', { content: String(content), time });
}

export function getNotchHeight() {
  if (window.zuzuche && window.zuzuche.getNotchHeight) {
    return window.zuzuche.getNotchHeight() / window.devicePixelRatio;
  }
  return 0;
}

/**
 * 检查app是否有权限 （iOS app版本从1.21.0开始支持）
 * @param {Array} permissions
 * @return {Object} data :{permissions[0]:true,permission[1]:false}
 */
export const hasPermission = permissions => new Promise(resolve => {
  zzc.call('native_hasPermissions', {
    permissions: [...permissions],
    success: resolve,
  });
});

/**
 * 请求app权限 （iOS app版本从1.21.0开始支持）
 * @param {String} permission
 * @return {Boolean} data:true/false
 */
export const requestPermissions = permission => new Promise(resolve => {
  zzc.call('native_requestPermissions', {
    permission,
    success: resolve,
  });
});

/**
 * 跳转app权限管理页面 （iOS app版本从1.21.0开始支持）
 * @return {Boolean} data:true/false
 */
export const jumpPermissionSetting = () => new Promise(resolve => {
  zzc.call('jump_permission_setting', {
    success: resolve,
  });
});

/**
 * 显示信息流广告
 *
 * @date 2020-03-06
 * @export
 * @returns
 */
export const showFeedAd = (options = {}, type) => {
  if (type === 'beiye') {
    options.byAdId = isAndroid ? options.byAndroid : options.byIos;
    // delete options.byAndroid;
    // delete options.byIos;
  }
  const adVersion = computedVideoVersion();
  const defaultSlots = {
    v1: {
      android: '945132121',
      ios: '945132441',
    },
    v2: {
      android: '945904137',
      ios: '945887098',
    },
  };
  if (!options.slotId) {
    const androidSlotId = options.android || defaultSlots[adVersion].android;
    const iosSlotId = options.ios || defaultSlots[adVersion].ios;
    options.slotId = isAndroid ? androidSlotId : iosSlotId;
    // delete options.ios;
    // delete options.android;
  }

  const params = {
    byAdId: options.byAdId || '',
    slotId: options.slotId || '',
  };


  const defaultOptions = {
    sizeStr: '375*94', // 可选字段  默认 '690*388' 可选范围（'690*388' '228*150'）
    x: '0',
    y: '0',
    w: '375',
    h: '94',
  };

  return new Promise(resolve => {
    if (window.zzc && window.zzcjsbridge && window.zzcjsbridge.showFeedAd) {
      zzc.call('showFeedAd', {
        ...defaultOptions,
        ...params,
        success: resolve,
      });
    }
  });
};

/**
 * 关闭信息流广告
 *
 * @date 2020-03-06
 * @export
 * @returns
 */
export const dismissFeedAd = () => new Promise(resolve => {
  if (window.zzc && window.zzcjsbridge && window.zzcjsbridge.dismissFeedAd) {
    zzc.call('dismissFeedAd', {
      success: resolve,
    });
  }
});

/**
 * 设置标题
 *
 * @param
 * @param
 */
export const setWebviewTitle = () => new Promise(resolve => {
  zzc.call('base_webviewTitle', {
    success: resolve,
  });
});

export const setPageHeadTitle = opt => new Promise(resolve => {
  if (isAPP && window.zzc) {
    zzc.call('base_webviewTitle', {
      ...opt,
      success: resolve,
    });
    document.title = opt.title;
  } else {
    document.title = opt.title;
  }
});

// /**
//  * 请求微信授权
//  * @param needInfo 前端是否需要微信返回的信息
//  */
// export const weChatAuthorize = (needInfo = false) => new Promise((resolve, reject) => {
//   zzc.call('account_appSocialSnsLogin', {
//     platform: 'wechat', // 要第三方登录的平台,目前只有wechat一种,
//     success: async response => {
//       if (response && response.state === 0) {
//         const result = await saveAuthInfo({
//           unionid: response.data.unionid,
//           openid: response.data.openid,
//           userName: response.data.userName,
//           iconURL: response.data.iconURL,
//         });
//         needInfo && resolve(response);
//         !needInfo && resolve(result);
//       } else {
//         reject(response);
//       }
//     },
//     error: reject,
//   });
// });

/**
 * 获取百川授权信息
 * 响应内容：
 * {
 *      "state": 0, // 0表示成功，其他为错误
 *      "message": "",  // 错误原因
 *      "data":{
 *          "nick":"xxx",
 *          "avatarUrl":"xxx",
 *          "openId":"xxx",
 *          "openSid":"xxx"
 *      }
 *  }
 */
export function callTaoBaoLogin() {
  console.log('call native : taoBaoLogin');
  return new Promise(resolve => {
    zzc.call('alibc_login', {
      complete(response) {
        resolve(response);
      },
    });
  });
}

/**
 * 配合url参数 topbar_hidden 使用，可以让前端实现导航栏渐变出现效果
 * http://wiki.int.zuzuche.info/pages/viewpage.action?pageId=7243724
 * @param options
 */
export const setSearchBarState = options => new Promise(resolve => {
  zzc.call('base_SetSearchBarState', {
    startOffset: '20',
    endOffset: '100',
    ...options,
    success: resolve,
  });
});

/**
 * 配合base_SetSearchBarState方法进行使用，可以让前端实现导航栏渐变出现效果,base_SetSearchBarState中的url，titleText无效
 * http://wiki.int.zuzuche.info/pages/viewpage.action?pageId=7243724
 * @param options
 */
export const updateWebTopSearchBar = options => new Promise(resolve => {
  zzc.call('base_updateWebTopSearchBar', {
    addBar: '0',
    startOffset: '20',
    endOffset: '100',
    ...options,
    success: resolve,
  });
});

/**
 * 判断是否安装淘宝
 */
export function hasInstallTaobao() {
  return new Promise((resolve, reject) => {
    zzc.call('base_phoneIsExistApp', {
      appName: isIOS ? 'tbopen://' : 'com.taobao.taobao',
      success: resolve,
      error: reject,
    });
  });
}

/**
 * 判断是否安装京东
 */
export function hasInstallJingDong() {
  return new Promise((resolve, reject) => {
    zzc.call('base_phoneIsExistApp', {
      appName: isIOS ? 'jdlogin' : 'com.jingdong.app.mall',
      success: resolve,
      error: reject,
    });
  });
}

/**
 * 判断是否安装拼多多
 */
export function hasInstallPDD() {
  return new Promise((resolve, reject) => {
    zzc.call('base_phoneIsExistApp', {
      appName: isIOS ? 'pinduoduo://' : 'com.xunmeng.pinduoduo',
      success: resolve,
      error: reject,
    });
  });
}
/**
 * 获取剪贴板的内容
 */
export function getClipboardContent() {
  return new Promise((resolve, reject) => {
    zzc.call('base_getNativeClipboard', {
      success: resolve,
      error: reject,
    });
  });
}

/**
 * 判断是否安装唯品会
 */
export function hasInstallVIP() {
  return new Promise((resolve, reject) => {
    zzc.call('base_phoneIsExistApp', {
      appName: isIOS ? 'vipshop://' : 'com.achievo.vipshop',
      success: resolve,
      error: reject,
    });
  });
}

/**
 * 判断是否安装考拉
 * ios无
 */
export function hasInstallKaoLa() {
  return new Promise((resolve, reject) => {
    zzc.call('base_phoneIsExistApp', {
      appName: isIOS ? 'kaola' : 'com.kaola',
      success: resolve,
      error: reject,
    });
  });
}

/**
 * 监听页面显示隐藏
 * callback true , 表示显示，false ， 表示隐藏
 */
export function onAppVisibilityChange(callback) {
  const listener = function (res) {
    // 原生插件命名问题。hidden为false，表示原页面隐藏
    const isShow = res.hidden;
    callback(isShow);
  };
  window.zzc.on('visibilitychange', listener);
  return () => window.zzc.off('visibilitychange', listener);
}

export function onReadTimeSa(callback) {
  if (isAPP) {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') {
        callback && callback();
      }
    });
    window.zzc.on('appPagePopUp', () => {
      callback && callback();
    });
  } else {
    window.onpopstate = () => {
      callback && callback();
    };
    window.onbeforeunload = () => {
      callback && callback();
    };
  }
}

/**
 * 头条小视频广告
 */
export function showDrawVideo(options = {}) {
  // console.log('======', duration, activityType, taskType, userTaskId);
  return new Promise(resolve => {
    zzc.call('showDrawVideo', {
      // duration, // 页面需停留的时间(s)
      // activityType, // 活动类型
      // taskType, // 任务类型
      // userTaskId, // 任务记录id
      ...options,
      success: resolve,
    });
  });
}

export function showNews(options = {}) {
  return new Promise(resolve => {
    zzc.call('showNews', {
      // duration: '10', // 页面需停留的时间(s)
      // activityType: '', // 活动类型
      // taskType: '', // 任务类型
      // userTaskId: '', // 任务记录id
      ...options,
      success: resolve,
    });
  });
}

export function showYmNovel(url = null) {
  zzc.call('showYmNovel', {
    url,
    success: () => { },
  });
}

/**
 * 打开小程序
 */
export function openWxMiniProgram({
  appId, path, updateShowFn, updateCancelFn, updateConfirmFn,
  type = config.miniProgramVersion,
}) {
  // alert(appVersion);
  if (isAPP && !version.versionCompare(appVersion, '1.25.0')) {
    Dialog.confirm({
      title: '',
      message: '您APP当前版本不支持该功能，请您更新至最新版本后参与，立即更新吧~~',
      showCancelButton: true,
      confirmButtonText: '立即更新',
    }).then(() => {
      window.location.href = `${version.appDownloadUrl}&ckey=CK1439223791341`;
    }).catch(() => {
      // on cancel
    });

    return;
  } if (!isAPP) {
    updateShowFn && updateShowFn();
    Dialog.confirm({
      title: '',
      message: '当前操作仅支持在最新版本APP上进行，赶紧下载全球购骑士卡APP参与活动吧~',
      showCancelButton: true,
      confirmButtonText: '立即下载',
    }).then(() => {
      updateConfirmFn && updateConfirmFn();
      window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.black.unique&ckey=CK1453746142284';
    }).catch(() => {
      // on cancel
      updateCancelFn && updateCancelFn();
    });

    return;
  }
  // eslint-disable-next-line consistent-return
  return new Promise(resolve => {
    accountAppSocialSnsLogin().then(res => {
      if (+res.state !== 0) {
        Toast('微信授权失败');
        return;
      }
      window.zzc.call('openMiniProgram', {
        appId,
        path,
        platform: '1',
        type, // 正式
        // type: '1', // 体验版
        // type: '2', // 预览版
        success(res2) {
          resolve(res2);
        },
        complete() {
        },
      });
    });
  });
}

/*
* 兼容新旧版本穿山甲id
* @returns
* 大于等于 1.39.0 使用新的穿山甲id v2
* 少于 1.39.0 使用旧的穿山甲id v1
 */
export function computedVideoVersion() {
  // eslint-disable-next-line camelcase
  const bigger_2_0_5 = isAPP && version.versionCompare(appVersion, '2.0.5');
  // eslint-disable-next-line camelcase
  if (bigger_2_0_5) {
    return 'v2';
  }
  return 'v1';
}
/**
 * 获取授权,默认获取微信授权
 * 要第三方登录的平台,目前只有wechat一种
 */
export function accountAppSocialSnsLogin(platform = 'wechat') {
  return new Promise(resolve => {
    window.zzc.call('account_appSocialSnsLogin', {
      platform, // 要第三方登录的平台,目前只有wechat一种
      success(response) {
        // response.state == 0 成功
        resolve(response);
      },
    });
  });
}

/*
* 检测是否支持该 api
* */
export function canUse(name) {
  return !!(window.zzcjsbridge && window.zzcjsbridge[name]);
}

export function zzcCall(api, opt) {
  return new Promise((res, ret) => {
    window.zzc.call(api, {
      ...opt,
      success(response) {
        if (response.state === 0) res(response);
        else ret(new Error(response.message));
      },
      complete(response) {
        if (response.state === 0) res(response);
        else ret(new Error(response.message));
      },
      error: ret,
    });
  });
}

/*
* 商城接口需要在headers 传
* device-type
* device-value
*/
export async function getAppIDInfo() {
  if (!canUse('base_localStorageGetItem')) {
    return null;
  }
  try {
    // idfa码，只有ios有
    const idfaResponse = await zzcCall('base_localStorageGetItem', {
      key: 'IDFA',
      namespace: isIOS ? 'vipCard' : '',
    });
    // 通用utdid码
    const utdidResponse = await zzcCall('base_localStorageGetItem', {
      key: 'UTDID',
    });
    const IDFA = idfaResponse.data || '';
    const UTDID = utdidResponse.data || '';
    if (!IDFA && !UTDID) {
      return null;
    }
    return {
      IDFA,
      UTDID,
    };
  } catch (error) {
    return null;
  }
}

/**
 * 告知原生相关信息
*/
export function postNotice(postContent) {
  return new Promise(resolve => {
    window.zzc.call('postNotice', {
      noticeName: postContent, // 通知名
      data: {}, // 通知携带的额外数据，可选
      success: resolve,
    });
  });
}


/**
 * 外卖返利宝唤起原生登陆
 */
export function callTakeoutRebatelogin(callback = () => {}) {
  window.UniqueJSBridge.call('userState.login', {}, rsp => {
    const result = typeof rsp === 'string' ? JSON.parse(rsp) : rsp;
    callback(result);
  });
}

// 哈士骑/返回前*个页面
export function popTo(options = {}, callback = () => {}) {
  if (isRebateApp) {
    window.UniqueJSBridge.call('jump.popTo', options, callback);
  } else {
    window.zzc.call('base_goBackPage', {
      step: options.index,
    });
  }
}

// 哈士骑/页面后退
export const backToPreviousPage = () => {
  if (isAPP) {
    if (isRebateApp) {
      popTo({
        index: -1,
      });
    } else {
      window.zzc.call('base_backToPreviousPage');
    }
  } else if (isBoxAPP) {
    UniquePopTo({
      animation: true, // 是否带动画推出界面，默认yes
      index: 1,
      jsFunName: () => {},
    });
  } else {
    history.go(-1);
  }
};

// 外卖返利宝获取token
export async function getAuthTokenBridge() {
  if (!isRebateApp) {
    return '';
  }

  const authToken = await getDataWithTypeAndKey('common', 'authToken');

  if (!authToken || authToken === 'null') {
    return '';
  }
  return authToken;
}

export const getDataWithTypeAndKey = (
  type = 'common',
  key = '',
  defaultValue = '',
) => new Promise((resolve, reject) => {
  getData({ type, key }, res => {
    try {
      const parsedRes = JSON.parse(res);
      const { code, data } = parsedRes;

      if (code !== '0') {
        resolve(defaultValue || '');
        return;
      }

      resolve(data[key]);
    } catch (e) {
      reject(e);
    }
  });
});

/**
 * 从统一存储获取数据
 ** @param {*} config: {
      type: "common",
      key: "key"
    }
 * @param {*} callback
 */
export function getData(params, callback) {
  window.UniqueJSBridge.call('dataStorage.getData', params, callback);
}
